/**
 * "Document model" do template Manutenção Preventiva CO2 Resinas — mesma
 * fonte de dados usada por `sections/Content.js` (PDF), extraída para um
 * array de blocos tipados e independente de React/JSX, consumido por
 * `_shared/generateDocx.js` para gerar o .docx.
 *
 * Mantém os mesmos IDs de pergunta, textos e ordem de seções de `Content.js`
 * (idêntico ao template `manutencao-preventiva-co2-lnp`, salvo o título da
 * capa) — ver esse arquivo para a fonte da verdade caso os dois um dia
 * divirjam.
 */
import { findReplyByQuestionId } from '../../_helpers/pdfHelpers'
import { questionBlocks } from '../../_shared/blockHelpers'
import { MONTHS } from '../../constants/dates'

export const buildDocumentModel = serviceOrder => {
  const { replies, endDate } = serviceOrder || {}

  const question359 = findReplyByQuestionId(replies, 359)
  const question363 = findReplyByQuestionId(replies, 363)
  const question365 = findReplyByQuestionId(replies, 365)
  const question366 = findReplyByQuestionId(replies, 366)
  const question367 = findReplyByQuestionId(replies, 367)
  const question368 = findReplyByQuestionId(replies, 368)
  const question370 = findReplyByQuestionId(replies, 370)
  const question373 = findReplyByQuestionId(replies, 373)
  const question375 = findReplyByQuestionId(replies, 375)
  const question379 = findReplyByQuestionId(replies, 379)
  const question380 = findReplyByQuestionId(replies, 380)
  const question381 = findReplyByQuestionId(replies, 381)
  const question383 = findReplyByQuestionId(replies, 383)
  const question384 = findReplyByQuestionId(replies, 384)
  const question385 = findReplyByQuestionId(replies, 385)
  const question386 = findReplyByQuestionId(replies, 386)
  const question387 = findReplyByQuestionId(replies, 387)

  const currentMonth = new Date(endDate).getMonth()
  const currentYear = new Date(endDate).getFullYear()

  const blocks = [
    {
      type: 'coverPage',
      lines: [
        'SABIC CENTRAL CO2 RESINAS',
        'MANUTENÇÃO PREVENTIVA SUPRESSÃO POR CO2',
        `${MONTHS[currentMonth]?.toUpperCase()} - ${currentYear}`
      ]
    },
    { type: 'pageBreak' },
    { type: 'toc' },
    { type: 'pageBreak' },

    { type: 'heading', level: 1, text: '1. Introdução' },
    {
      type: 'paragraph',
      text: 'Este Relatório tem como objetivo expressar as atividades realizadas pela empresa Easy Solutions, bem como substituição de dispositivos danificados, visando informar sempre as melhorias cabíveis ao sistema de acordo com a necessidade de cada cliente e atender a NBR 17240-2010 (Sistema de Detecção e Alarme de Incêndio, Projetos, Instalações e Manutenções do Sistema).'
    },

    { type: 'heading', level: 1, text: '2. Ferramentas utilizadas para Testar Detectores', pageBreakBefore: true },
    {
      type: 'paragraph',
      text: 'A Easy Solutions possui o Kit para testar Detectores Térmico, utilizam Soprador Térmico, equipamentos que atendem as Normas Internacionais de Fire Alarm NBR-17240-2010, conforme figura abaixo.'
    },
    { type: 'imageGrid', images: [{ src: '/pdfs/easysolutions/soprador_termico2.png', description: 'Figura 1 - Soprador Térmico' }] },

    { type: 'heading', level: 1, text: '3. Serviços Realizados', pageBreakBefore: true },
    ...questionBlocks(question359),
    ...questionBlocks(question363),
    ...questionBlocks(question365),
    ...questionBlocks(question366),
    ...questionBlocks(question367),

    { type: 'heading', level: 1, text: '4. Tensão da Central de Incêndio', pageBreakBefore: true },
    { type: 'keyValue', label: question368?.question?.name, value: Array.isArray(question368?.value) ? '' : question368?.value ?? 'N/A' },
    ...(question368?.documents?.length ? [{ type: 'imageGrid', images: question368.documents.filter(d => d?.src).map(d => ({ src: d.src, description: d.description })) }] : []),

    // Nota: `Content.js` (PDF) renderiza question373/375 duas vezes nesta seção
    // (aparenta ser um copy-paste acidental do legado, não uma repetição
    // proposital). Fora de escopo corrigir aqui — mantido igual ao PDF para os
    // dois formatos não divergirem.
    { type: 'heading', level: 1, text: '5. Teste do Sistema', pageBreakBefore: true },
    ...questionBlocks(question373),
    ...questionBlocks(question375),
    ...questionBlocks(question379),
    ...questionBlocks(question380),
    ...questionBlocks(question370),
    ...questionBlocks(question373),
    ...questionBlocks(question375),

    { type: 'heading', level: 1, text: '6. Status do sistema de supressão por CO2 ao sair', pageBreakBefore: true },
    ...questionBlocks(question381),
    ...questionBlocks(question383),
    ...questionBlocks(question384),
    ...questionBlocks(question385),

    { type: 'heading', level: 1, text: '7. Melhoria no sistema', pageBreakBefore: true },
    ...questionBlocks(question386),

    { type: 'heading', level: 1, text: '8. Conclusão', pageBreakBefore: true },
    ...questionBlocks(question387)
  ]

  return {
    title: `SABIC CENTRAL CO2 RESINAS - Manutenção Preventiva - ${MONTHS[currentMonth]} ${currentYear}`,
    blocks
  }
}

export default buildDocumentModel
